<template>
  <div class="ibox-content">
    <div class="row table-responsive">
      <div style="font-size: 24px; font-weight: 500; margin-bottom: 27px">
        Promotion Events
      </div>
      <div class="search-wrap">
        <div class="search-item">
          <label class="col-sm-2 control-label"> Event Title </label>
          <div class="col-sm-4">
            <el-input
              v-model="promotionSearchParams.title"
              clearable
            ></el-input>
          </div>
          <div class="btn-wrap" v-if="userRole != 0">
            <el-button @click="getPromotionList()" type="primary">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
        <div class="search-item" v-if="userRole == 0">
          <label class="col-sm-2 control-label"> District </label>
          <div class="col-sm-4">
            <el-select
              v-model="promotionSearchParams.districtCode"
              v-bind:placeholder="$t('message.PleaseSelect')"
              name="eventDistrictCode"
              clearable
              filterable
            >
              <el-option
                v-for="item in districtGetlist"
                :key="item.districtCode"
                :label="item.districtNameEn"
                :value="item.districtCode"
              >
              </el-option>
            </el-select>
          </div>
          <div class="btn-wrap">
            <el-button @click="getPromotionList()" type="primary">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row table-responsive">
      <div class="col-xs-12 add-btn">
        <el-button @click="handleArchiveEvent">{{
          archive ? "Unarchive" : "Archive"
        }}</el-button>
        <el-button
          v-if="!archive && checkPermission('SchoolEvent_LIST_ADD')"
          @click="handleNavToPromotionDetail"
          icon="el-icon-plus"
          type="primary"
          >Add</el-button
        >
      </div>
    </div>
    <div class="row table-responsive" style="padding-bottom: 60px">
      <div class="col-xs-12">
        {{ promotionTotal }}{{ $t("message.datagridresult") }}
      </div>
      <el-table
        :data="promotionList"
        style="width: 100%"
        ref="multipleTable"
        :fit="true"
        border
        class="rowss"
        row-key="id"
        :cell-class-name="cell"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          label="Event title"
          prop="eventTitle"
          sortable
          :show-overflow-tooltip="true"
          min-width="200"
        >
          <template slot-scope="scope">
            <div>
              <el-tag
                type="warning"
                effect="dark"
                size="mini"
                v-if="scope.row.expired"
              >
                Expired
              </el-tag>
              {{ scope.row.eventTitle }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="eventDistrict"
          label="Event District"
        ></el-table-column>
        <el-table-column
          label="IDEAS category"
          prop="ideasCategory"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="Event Date"
          prop="startEventDate"
          sortable
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column label="Status Name">
          <template slot-scope="scope">
            {{
              scope.row.status == "0"
                ? "DRAFT"
                : scope.row.status == "4"
                ? "SUSPEND"
                : "PUBLISH"
            }}
          </template>
        </el-table-column>

        <el-table-column label="Last update time" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ $dayjs(scope.row.lastUpdateTime).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column width="250">
          <template slot-scope="scope" v-if="!archive">
            <el-popconfirm
              title="Are you sure you want to modify the status?"
              confirmButtonText="Yes"
              cancelButtonText="No"
              @confirm="updateStatusEvent(scope.row.id, 6)"
              v-if="scope.row.status == 0"
            >
              <el-button
                size="mini"
                type="primary"
                slot="reference"
                style="width: 110px"
              >
                PUBLISH
              </el-button>
            </el-popconfirm>

            <el-popconfirm
              title="Are you sure you want to modify the status?"
              confirmButtonText="Yes"
              cancelButtonText="No"
              @confirm="updateStatusEvent(scope.row.id, 4)"
              v-if="scope.row.status == 6"
            >
              <el-button
                size="mini"
                type="primary"
                slot="reference"
                style="width: 110px"
                class="el-button-blue"
                >SUSPEND
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>

        <el-table-column label="Action" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="handleNavToPromotionDetail(scope.row)"
              size="mini"
              ><i class="el-icon-edit"></i
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="el-table_footertoolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handlePromotionSizeChange"
          @current-change="handlePromotionCurrentChange"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="promotionSearchParams.pageSize"
          :total="promotionTotal"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import axios from "axios";
import Sortable from "sortablejs";

export default {
  mixins: [config.globalMixin],
  components: {},
  props: {
    archive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      promotionSearchParams: {
        pageSize: 10,
        pageIndex: 1,
        sortName: "",
        sortType: "ASC",
        sortField: "sortOrder",
        ideasCategory: "",
        title: "",
        type: "",
        archivedStatus: 0,
        parentId: 0,
        status: "",
        districtCode: "",
      },
      promotionList: [],
      promotionTotal: 0,
      multipleSelection: [],
      districtGetlist: [],
      canDrag:false
    };
  },
  computed: {
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
    userRole() {
      const res = JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType;
    },
  },
   created: function () {
    if (this.checkPermission("SchoolEvent_LIST_ORDER")) {
      this.canDrag = true;
    }
  },
  mounted() {
    if (this.userRole == 0)
      this.promotionSearchParams.districtCode = JSON.parse(
        sessionStorage.getItem("userInfo")
      ).userDistrictCode;
    this.intiPage();
  },
  methods: {
    cell: function ({ row }) {
      if (!this.canDrag) {
        return "disabled pointer";
      }
      // if (row.status == 1) {
      return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    intiPage() {
      this.getPromotionList();
      this.getDistrictGetlist();
      const table = document.querySelector(
        ".rowss .el-table__body-wrapper tbody"
      );
      const self = this;
      Sortable.create(table, {
        onEnd({ newIndex, oldIndex }) {
          self.updatePromotionListSort(newIndex, oldIndex);
        },
        filter: ".disabled",
        onMove: (event) => {
          return !event.related.classList.contains("disabled");
        },
      });
    },
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    async updatePromotionListSort(newIndex, oldIndex) {
      const item = this.promotionList[oldIndex];
      this.promotionList.splice(oldIndex, 1);
      this.promotionList.splice(newIndex, 0, item);
      const lstOrderDTO = this.promotionList.map((i) => {
        return {
          id: i.id,
          displayOrder: i.sortOrder,
        };
      });
      const param = {
        lstOrderDTO,
        ...this.userInfo,
      };
      const {
        data: { status_code, status_message },
      } = await axios.post(this.baseURL + "schoolEvent/order", {
        ...param,
      });
      if (status_code == "0") {
        this.getPromotionList();
      } else if (status_code == "000104") {
        this.timeoutEvent();
        return;
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async getPromotionList(isGoFristPage) {
      if (isGoFristPage) this.promotionSearchParams.pageIndex = 1;
      let searchParam = this.getAuthObj();
      searchParam = {
        ...searchParam,
        sourceType: 1,
        ...this.promotionSearchParams,
        archivedStatus: this.archive ? 1 : 0,
        apiUrl: this.apiConfig.schoolEventList,
      };
      let data = await this.$store.dispatch("apiEvent", searchParam);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.promotionList = data.data.result.schoolEvents;
      this.promotionTotal = data.data.result.total;
    },
    handlePromotionSizeChange(val) {
      this.promotionSearchParams.pageSize = val;
      this.getPromotionList("goFristPage");
    },
    handlePromotionCurrentChange(val) {
      this.promotionSearchParams.pageIndex = val;
      this.getPromotionList();
    },
    handleNavToPromotionDetail(row) {
      this.$router.push({
        path: "/main/promotionEventDetail",
        query: {
          id: row.id,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((i) => {
        return i.id;
      });
    },
    async updateStatusEvent(id, status) {
      var objdata = this.getAuthObj();
      objdata.id = id;
      objdata.status = status;
      objdata.apiUrl = "/schoolEvent/updateStatus";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      this.getPromotionList();
      if (!data) return;
    },
    async handleArchiveEvent() {
      const param = {
        lstSchoolEventId: this.multipleSelection,
        status: this.archive ? 0 : 1,
        ...this.userInfo,
      };
      const {
        data: { status_code, status_message },
      } = await axios.post(
        this.baseURL + "schoolEvent/updateArchivedStatus",
        param
      );
      if (status_code == "0") {
        this.getPromotionList();
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-btn {
  display: flex;
  justify-content: flex-end;
}
.search-wrap {
  display: flex;
  flex-direction: column;
  .search-item {
    margin-bottom: 15px;
    display: flex;
    .entry-no-wrap {
      display: flex;
      .separator {
        margin: 0 10px;
        display: flex;
        align-items: center;
      }
    }
    .btn-wrap {
      display: flex;
      justify-self: flex-end;
    }
  }
}
.status-color {
  color: #fff;
  background-color: #a0cfff !important;
  border-color: #a0cfff !important;
}
</style>